var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#009EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7425 7.1572C14.7165 7.3197 14.7035 7.4822 14.7035 7.6447C14.7035 9.1072 15.8865 10.2895 17.3425 10.2895C17.505 10.2895 17.661 10.2707 17.8235 10.2447V15.4896C17.8235 17.6937 16.5235 19.0002 14.3135 19.0002H9.51065C7.3 19.0002 6 17.6937 6 15.4896V10.6802C6 8.4702 7.3 7.1572 9.51065 7.1572H14.7425ZM14.8732 11.1092C14.697 11.0897 14.5222 11.1677 14.4175 11.3107L12.8452 13.3452L11.044 11.9282C10.9335 11.8437 10.8035 11.8106 10.6735 11.8242C10.5442 11.8437 10.4272 11.9146 10.3485 12.0186L8.42515 14.5217L8.3855 14.5802C8.275 14.7876 8.327 15.0541 8.522 15.1977C8.613 15.2562 8.7105 15.2952 8.821 15.2952C8.97115 15.3017 9.1135 15.2231 9.2045 15.1002L10.836 13.0001L12.6885 14.3917L12.747 14.4301C12.955 14.5406 13.215 14.4892 13.3645 14.2936L15.243 11.8697L15.217 11.8827C15.321 11.7397 15.3405 11.5577 15.269 11.3952C15.1982 11.2327 15.0415 11.1222 14.8732 11.1092ZM17.4336 6C18.2981 6 19.0001 6.702 19.0001 7.5665C19.0001 8.431 18.2981 9.133 17.4336 9.133C16.5691 9.133 15.8671 8.431 15.8671 7.5665C15.8671 6.702 16.5691 6 17.4336 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsFilled);
export default __webpack_public_path__ + "static/media/about-us-filled.6a10d3e2e6558c44b3d0bc27c33a450b.svg";
export { ForwardRef as ReactComponent };